module.exports = __webpack_public_path__ + "img/05.0523e34b.png";